if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const variantId = formData.get('id');
const quantity = parseInt(formData.get('quantity')) || 1;

// Mapa de "variante comprada -> variante regalo", para productos donde el color del regalo
// debe coincidir (o parecerse) al color elegido. Se comprueba ANTES que las reglas genéricas.

  const variantGiftMap = {
  // Verde oliva -> Bolsa Hobo Verde oliva
  '55157330149705': '55161715753289',
  '55157330182473': '55161715753289',
  '55157330215241': '55161715753289',
  '55157330248009': '55161715753289',
  '55157330280777': '55161715753289',
  '55157330313545': '55161715753289',

  // Gris -> Bolsa Hobo Gris
  '55157331067209': '55161715786057',
  '55157331263817': '55161715786057',
  '55157331460425': '55161715786057',
  '55157331657033': '55161715786057',
  '55157331853641': '55161715786057',
  '55157332050249': '55161715786057',

  // Negro -> Bolsa Hobo Negro
  '55157331099977': '55161715818825',
  '55157331296585': '55161715818825',
  '55157331493193': '55161715818825',
  '55157331689801': '55161715818825',
  '55157331886409': '55161715818825',
  '55157332083017': '55161715818825',

  // Rojo -> Bolsa Hobo Gris
  '55157331132745': '55161715786057',
  '55157331329353': '55161715786057',
  '55157331525961': '55161715786057',
  '55157331722569': '55161715786057',
  '55157331919177': '55161715786057',
  '55157332115785': '55161715786057',

  // Blanco -> Bolsa Hobo Gris
  '55157331165513': '55161715786057',
  '55157331362121': '55161715786057',
  '55157331558729': '55161715786057',
  '55157331755337': '55161715786057',
  '55157331951945': '55161715786057',
  '55157332148553': '55161715786057',

  // Rosa -> Bolsa Hobo Gris
  '55157331198281': '55161715786057',
  '55157331394889': '55161715786057',
  '55157331591497': '55161715786057',
  '55157331788105': '55161715786057',
  '55157331984713': '55161715786057',
  '55157332181321': '55161715786057',
};

// Reglas de "producto trigger -> regalo automático", para productos donde el regalo es siempre el mismo
// sin importar el color. Cada regla se identifica por productId y/o un fragmento de la URL, como respaldo.
const giftRules = [
  {
    productId: '10258733269321',
    pathIncludes: '/products/mariateresa',
    giftVariantId: '54612966834505', // Collar
  },
  {
    productId: '10379860869449',
    pathIncludes: '/products/conjunto-amelia',
    giftVariantId: '55257182798153', // Bolsa Alma Marfil (blanco)
  },
];

const currentProductId = this.form.dataset.productId;
const currentPath = window.location.pathname;

// 1) Primero comprobamos si la variante exacta tiene un regalo asignado por color
let giftVariantId = variantGiftMap[variantId];

// 2) Si no, comprobamos las reglas genéricas (regalo fijo, sin importar color)
if (!giftVariantId) {
  const matchedRule = giftRules.find((rule) => {
    const matchesId = currentProductId && currentProductId === rule.productId;
    const matchesPath = rule.pathIncludes && currentPath.includes(rule.pathIncludes);
    return matchesId || matchesPath;
  });
  if (matchedRule) {
    giftVariantId = matchedRule.giftVariantId;
  }
}

// Debug: abre la consola del navegador (F12 -> Console) y agrega el producto al carrito.
// Aqui veras exactamente que valores esta detectando el codigo.
console.log('[Gift Debug] variantId:', variantId, '| currentProductId:', currentProductId, '| currentPath:', currentPath, '| giftVariantId:', giftVariantId);

if (giftVariantId) {
  formData.append('items[1][id]', giftVariantId);
  formData.append('items[1][quantity]', 1);
}

config.body = formData;
        const linesUpdateDeferred = this.createCartLinesUpdateEvent(variantId, quantity);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}